import React from "react";
import { PROCESS } from "../../mock";

export default function Process() {
  return (
    <section id="process" className="py-24 lg:py-32 bg-slate-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.10]" style={{
        backgroundImage:
          "radial-gradient(circle at 20% 20%, #38bdf8 0%, transparent 35%), radial-gradient(circle at 80% 80%, #60a5fa 0%, transparent 40%)"
      }}/>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="section-eyebrow" style={{ color: "#7dd3fc" }}>
            How we work
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
            A simple, transparent process from day one.
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed">
            No black boxes, no surprise invoices. Here&rsquo;s exactly what working with us looks like.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS.map((p, i) => (
            <div
              key={p.step}
              className="relative rounded-2xl bg-white/5 border border-white/10 p-7 hover:bg-white/10 transition-colors"
            >
              <div className="text-5xl font-semibold text-sky-300/30 leading-none">
                {p.step}
              </div>
              <h3 className="mt-5 text-xl font-semibold">{p.title}</h3>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">
                {p.body}
              </p>
              {i < PROCESS.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-3 h-px w-6 bg-sky-400/40" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
